// extracted by mini-css-extract-plugin
module.exports = {"underlineText":"u2xwearR"};